import { render, staticRenderFns } from "./mediate.vue?vue&type=template&id=369ad1b0&scoped=true&"
import script from "./mediate.vue?vue&type=script&lang=js&"
export * from "./mediate.vue?vue&type=script&lang=js&"
import style0 from "./mediate.vue?vue&type=style&index=0&id=369ad1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369ad1b0",
  null
  
)

export default component.exports